/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export enum KnownProgram {
  System,
  Token,
  Token2022,
  Rent,
  Stake,
  Vote,
  BpfLoader,
  UpgradeableLoader,
  SysvarConfig,
}

export type KnownProgramArgs = KnownProgram;

export function getKnownProgramEncoder(): Encoder<KnownProgramArgs> {
  return getEnumEncoder(KnownProgram);
}

export function getKnownProgramDecoder(): Decoder<KnownProgram> {
  return getEnumDecoder(KnownProgram);
}

export function getKnownProgramCodec(): Codec<KnownProgramArgs, KnownProgram> {
  return combineCodec(getKnownProgramEncoder(), getKnownProgramDecoder());
}
